"use client";

import React from "react";
import { Button } from "@helder-nicollas/govbr-react-components/button";

type GovButtonProps = {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
};

export function GovButton({
  children,
  onClick,
  type = "button", // <- garante que não submete o form
  disabled = false,
}: GovButtonProps) {
  return (
    <Button variant="primary" type={type} onClick={onClick} disabled={disabled}>
      {children}
    </Button>
  );
}
